/**
 * Variant to define styling of EnDashboardIconWrapper.
 */
export const EnDashboardIconVariants = Object.freeze({
    Primary: 'primary',
    Secondary: 'secondary',
    Navigation: 'navigation',
});
